import { Box, Avatar, Text, Badge, Image, Flex, Tooltip, Progress, CircularProgress, CircularProgressLabel } from "@chakra-ui/react";
import CopyIcon from "../../../../../assets/images/CopyIcon.svg";
import BranchIcon from "../../../../../assets/images/BranchIcon.svg";
import CompanyIcon from "../../../../../assets/images/companyIcon.svg";
import InboxIcon from "../../../../../assets/images/InboxIcon.svg";
import CallIcon from "../../../../../assets/images/CallIcon.svg";
import DummyPerson from "../../../../../assets/images/DummyPerson.svg"
import MyDiv from "./employeeCard.style";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as routesNames from '../../../../../constants/routes'
import { CustomToast } from "../../../../../components";
import { EmployeeCardProps, EmployeeModel, ripple } from "./modal";

const PROFILE_WEIGHTS = {
  personal: 25,
  employer: 25,
  family: 10,
  education: 15,
  bank: 10,
  documents: 15
};




const EmployeeCard = ({ employee, statusDD, reload, setReload }: EmployeeCardProps) => {
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const { addToast } = CustomToast();

  useEffect(() => {
    if (statusDD.length > 0 && employee.status) {
      const match = statusDD.find(s => s.employeeStatus === employee.status);
      if (match) {
        setStatus(match.id.toString());
      }
    }
  }, [statusDD, employee.status]);

  const handleEmployeeDetail = (employee: EmployeeModel) => {
    const employeeId = employee.id;
    navigate(routesNames.EMPLOYEEDETAIL, { state: { employeeId } });
  }

  const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    addToast({ message: `${type} copied!`, status: 'success' });
  }

  const profilePercent = employee.profileCompletion?.totalPercentage ?? 0;
  const getProfileColor = (percent: number) => {
    if (percent <= 40) return "red.400";
    if (percent <= 70) return "yellow.400";
    return "green.400";
  };

  const ProfileTooltip = ({ tabs }: { tabs: any }) => {
    return (
      <Box p={2}>
        {Object.entries(PROFILE_WEIGHTS).map(([key, max]) => (
          <Flex key={key} justify="space-between" align="center" gap={4} fontSize="12px" mb={1} >
            <Text textTransform="capitalize" color="gray.600">
              {key}
            </Text>
            <Text fontWeight="600">
              {tabs?.[key] ?? 0} / {max}
            </Text>
          </Flex>
        ))}
      </Box>
    );
  };


  return (
    <MyDiv>
      <Box className="card" cursor={"pointer"} onClick={() => handleEmployeeDetail(employee)}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box display="flex" >
            <Box position="relative" display="inline-block">
              <Avatar className="Avatar" name={employee.name} src={employee.avatarUrl || DummyPerson} />

              <Box position="absolute" bottom="4px" right="3px" w="15px" h="15px" borderRadius="full" bg={employee.isOnline ? "green.500" : "red.400"} border="2px solid white">
                {employee.isOnline && (
                  <Box position="absolute" inset={0} borderRadius="full" bg="green.400" animation={`${ripple} 1.8s infinite`} />
                )}
              </Box>
            </Box>

            <Box className="employee-info" ml={2}>

              <Box>
                <Flex gap={2} alignItems={"center"}>
                  <Tooltip className="font-poppins text_medium text_xl" label={employee.name} placement="bottom" hasArrow>
                    <Text className="font-poppins text_medium text_xl" maxWidth="11vw" isTruncated color={employee.status === "Active" ? "green.500" : "red.500"}>{employee.name}</Text>
                  </Tooltip>
                  <Badge variant="subtle" className="Badge font_dark font-poppins text_medium text_xsm" px={2} py={1} >
                    {employee.empCode}
                    <Image src={CopyIcon} alt="Copy" boxSize="11px" cursor="pointer" onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(employee.empCode, "Employee Code");
                    }} />
                  </Badge>
                </Flex>
              </Box>

              <Box display="flex" gap={2} mt={1}>
                <Tooltip label={employee?.designation}>
                  <Text className="font-poppins text_sm text_medium common_color" maxWidth="9vw" isTruncated>
                    <Badge variant="subtle" className="desig font-poppins text_medium text_xsm">{employee.designation}</Badge>
                  </Text>
                </Tooltip>
                <Text className="font-poppins text_medium text_xsm" color="rgba(73, 80, 87, 1)">{employee.department}</Text>
              </Box>
            </Box>
          </Box>
          <Tooltip hasArrow placement="left" bg="white" color="black" borderRadius="md" boxShadow="lg" label={<ProfileTooltip tabs={employee.profileCompletion?.tabs} />}
          >
            <Box>
              <CircularProgress
                value={profilePercent}
                size="56px"
                thickness="6px"
                color={getProfileColor(profilePercent)}
                trackColor="gray.200"
              >
                <CircularProgressLabel
                  fontSize="12px"
                  fontWeight="600"
                  color={getProfileColor(profilePercent)}
                >
                  {profilePercent}%
                </CircularProgressLabel>
              </CircularProgress>
            </Box>
          </Tooltip>

          {/* <Text className="font-poppins text_medium text_xsm" px={2} py={1} borderRadius="4px" bg={statusDD.find((s) => s.id.toString() === status)?.employeeStatus === "Active" ? "#F0FFF4" : "#FFF5F5"} color={statusDD.find((s) => s.id.toString() === status)?.employeeStatus === "Active" ? "#38A169" : "#E53E3E"} textAlign="center">
            {statusDD.find((s) => s.id.toString() === status)?.employeeStatus || "N/A"}
          </Text> */}
        </Box>

        <Box className="branch">
          <Box mt={2} ml={1}>
            <Box className="info-group" display="flex" flexDirection="column" gap={2}>
              {[{ icon: BranchIcon, label: "Branch", value: employee.branch },
              // { icon: CompanyIcon, label: "Payroll Company", value: employee.payrollCompany },
              { icon: CompanyIcon, label: "Company", value: employee.usCompany }].map((item, index) => (
                <Box key={index} display="flex" alignItems="center" gap={2}>
                  <Badge minW="25px" height="25px" borderRadius="full" bg="gray.100" display="flex" alignItems="center" justifyContent="center">
                    <Image src={item.icon} alt={item.label} boxSize="12px" />
                  </Badge>
                  <Box>
                    <Text className="font-poppins text_medium text_xsm" color="gray.500">{item.label}</Text>
                    <Text className="font-poppins text_medium text_xsm">{item.value}</Text>
                  </Box>
                </Box>
              ))}
            </Box>

            <Flex justifyContent="space-between" alignItems="center" mt={4}>
              <Box display="flex" gap={2}>
                <Tooltip label={`${employee.email}`} placement="top" hasArrow>
                  <Badge
                    minW="25px"
                    height="25px"
                    borderRadius="4px"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    _hover={{ bg: "gray.200" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(employee.email, "Email");
                    }}
                  >
                    <Image src={InboxIcon} alt="Inbox" cursor="pointer" />
                  </Badge>
                </Tooltip>

                <Tooltip label={`${employee.phone}`} placement="top" hasArrow>
                  <Badge
                    minW="25px"
                    height="25px"
                    borderRadius="4px"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    _hover={{ bg: "gray.200" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(employee.phone, "Phone number");
                    }}
                  >
                    <Image src={CallIcon} alt="Call" cursor="pointer" />
                  </Badge>
                </Tooltip>
              </Box>
              <Text className="btn font-poppins text_medium text_xsm" color="rgba(9, 146, 80, 1)" mr={3}>{employee.presence}</Text>
            </Flex>
          </Box>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default EmployeeCard;